
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CourseList extends Vue {
  @Prop() chooseItem: Function;
  @Prop() list: any[];

  curCourse: number = 0;

  changeActive($event: any) {
    $event.currentTarget.className = 'course-item active';
  }
  removeActive($event: any) {
    $event.currentTarget.className = 'course-item';
  }

  setCurCourse(item: any, index: number) {
    this.$emit('chooseItem', item);
    this.curCourse = index;
  }

  @Watch('list', { immediate: true, deep: true })
  changeList(list: any) {
    if (list.length > 0) {
      this.setCurCourse(list[0], 0);
    }
  }
}
